import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import useFilterCounter from "@/components/Filters/useFiltersCount";
import { debounce } from "lodash"

export default function useList() {
  const refListTable = ref(null);
  const toast = useToast();

  store.dispatch('victronenergy_master_account/getAll')
  const victronenergyMasterAccountOptions = computed(() => store.getters['victronenergy_master_account/getSelectedItems'])
  const victronenergyMasterAccountFilter = ref(null)

  store.dispatch("unit/getAll");
  const unitOptions = computed(() => store.getters['unit/getSelectedItems'])
  const unitFilter = ref(null);

  store.dispatch('tenant/getDeviceTags')
  const tagOptions = computed(() =>
    store.getters['tenant/getDeviceTags'].map(tag => ({
      value: tag.id,
      name: tag.name,
    }))
  )

  console.log(tagOptions)
  const tagFilter = ref(null);

  const tableColumns = [
    { label: "victronenergy.master_account.title", key: "master_account.name", sortable: true },
    { label: "victronenergy.sites.name", key: "name", sortable: true },
    { label: 'camera_proxy.id', key: 'camera.id', sortable: true },
    {
      label: 'unit.title', key: 'camera.units', sortable: false,
      formatter: (value, key, item) => {
        if (value) return value.map(item => { return item.description }).join(', ')
        return ""
      }
    },
    { label: 'device_tag.title', key: 'camera.device_tag.name', sortable: false },
    { label: "victronenergy.sites.timezone", key: "timezone", sortable: true },
    { label: "victronenergy.sites.status", key: "status", sortable: true },
    { label: "victronenergy.sites.has_mains", key: "has_mains", sortable: true },
    { label: "victronenergy.sites.has_generator", key: "has_generator", sortable: true },
    { label: "victronenergy.sites.device_icon", key: "device_icon", sortable: true },
    { label: "victronenergy.sites.favorite", key: "favorite", sortable: true },
    { label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned' },
    { label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned' },
  ];
  tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("victronenergy_sites/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        id_victronenergy_master_account: victronenergyMasterAccountFilter.value,
        id_unit: unitFilter.value,
        id_device_tag: tagFilter.value,
      })
      .then((response) => {
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([
    currentPage,
    perPage,
  ], () => {
    refetchData();
  });

  watch([searchQuery], debounce(() => { refetchData() }, 500))

  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      id_victronenergy_master_account: victronenergyMasterAccountFilter.value,
      id_unit: unitFilter.value,
      id_device_tag: tagFilter.value,
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    victronenergyMasterAccountFilter.value = null;
    unitFilter.value = null;
    tagFilter.value = null;
    buildFilters();
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    filtersCount,
    unitOptions,
    unitFilter,
    tagOptions,
    tagFilter,
    victronenergyMasterAccountOptions,
    victronenergyMasterAccountFilter,

    fetchList,
    refetchData,
    formatDateAssigned,
    buildFilters,
    clearSearchFilters,
  };
}
